var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.productStatusItems,"label":_vm.label,"outlined":_vm.outlined,"dense":_vm.dense},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(("product.product_status." + item))))])]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(("product.product_status." + item))))])]}}]),model:{value:(_vm.productStatus),callback:function ($$v) {_vm.productStatus=$$v},expression:"productStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }